<template>
    <div>
        <v-container fluid grid-list-md>
            <v-layout wrap align-center>
                <v-flex xs12 sm3 md3 d-flex>
                  <div>
                    <slot name="header_actions"></slot>
                  </div>
                </v-flex>
            </v-layout>
            <v-layout wrap align-center>
                <v-flex xs12 sm3 md3 d-flex>
                    <v-text-field
                            v-model="filters.query"
                            append-icon="search"
                            :label="trans('app.search.search')"
                            single-line
                            hide-details
                            solo
                            clearable
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3 d-flex>
                    <v-combobox
                            clearable
                            :items="[{text: trans('app.own'), value: 'own'},{text: trans('app.favorites'), value: 'favorites'},{text: trans('app.system'), value: 'system'}, {text: trans('app.shared'), value: 'shared'}]"
                            :label="trans('app.database')"
                            v-model="filters.database"
                            hide-details
                            solo
                    ></v-combobox>
                </v-flex>

                <v-flex xs12 sm3 md3 d-flex>
                    <v-combobox
                            multiple
                            clearable
                            :items="dictionaries.diets.map(t => t.name)"
                            :label="trans('page.tags.diet')"
                            v-model="filters.tags.diet"
                            hide-details
                            solo
                    ></v-combobox>
                </v-flex>

                <v-flex xs12 sm3 md3 d-flex>
                    <v-combobox
                            multiple
                            clearable
                            :items="dictionaries.schemas.map(t => t.name)"
                            :label="trans('app.tags.tags')"
                            v-model="filters.tags.schema"
                            hide-details
                            solo
                    ></v-combobox>
                </v-flex>

            </v-layout>
        </v-container>
        <v-data-table
                :disable-initial-sort="true"
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="total"
                :loading="isLoading"
                :rows-per-page-items="[10,25,50,100]"
        >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <tr>
                    <td style="width: 30px;">
                        <template v-if="props.item.tags.length > 0">
                            <v-tooltip top>
                                <template #activator="{ on }">
                                    <v-btn
                                            v-on="on"
                                            flat
                                            icon
                                            color="blue"
                                            @click="props.expanded = !props.expanded">
                                        <v-icon small>
                                            {{ props.expanded ? 'remove_circle_outline' : 'add_circle_outline' }}
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ 'app.details'  | trans }}</span>
                            </v-tooltip>
                        </template>
                    </td>
                    <td>
                        {{ props.item.title }}
                        <icon-tooltip :tooltip-text="trans('app.system_schema')" :enabled="props.item.system">
                          <v-btn flat icon color="success" class="mr-0 ml-0">
                            <i class="logo-small"></i>
                          </v-btn>
                        </icon-tooltip>
                        <icon-tooltip :tooltip-text="trans('app.sharing.shared_by', {name: props.item.owned_by})" :enabled="props.item.shared">
                          <v-icon small color="success">share</v-icon>
                        </icon-tooltip>
                    </td>
                    <td>{{ props.item.days }}</td>
                    <td>{{ props.item.desired_diet_energy | round }} kcal</td>
                    <td v-if="props.item.created_at">{{ props.item.created_at| format_date(FORMAT_DATETIME) }}</td>
                    <td v-else>{{ props.item.created_at }}</td>
                    <td class="justify-end layout px-0 pr-4">
                        <slot name="table-actions" :item="props.item"></slot>
                    </td>
                </tr>
            </template>
            <template slot="expand" slot-scope="props">
                <v-card flat color="#fafafa">
                    <v-card-text>
                        <div v-show="props.item.tags.filter(t => t.type === 'diet').length > 0">
                            <v-label>Dieta</v-label>
                            <v-chip label small outline color="success" :key="tag.name"
                                    v-for="tag in props.item.tags.filter(t => t.type === 'diet').map(t => t.name)">
                                {{tag}}
                            </v-chip>
                        </div>
                        <div v-show="props.item.tags.filter(t => t.type === 'schema').length > 0">
                            <v-label>Tagi</v-label>
                            <v-chip label small outline color="success" :key="tag.name"
                                    v-for="tag in props.item.tags.filter(t => t.type === 'schema').map(t => t.name)">
                                {{tag}}
                            </v-chip>
                        </div>
                    </v-card-text>
                </v-card>
            </template>
            <template v-slot:no-data>
              <div class="text-center">
                <span v-if="(filters.database && filters.database.value === 'shared') && !canUseSharing" v-html="trans('app.no_access_tooltip')">
                </span>
                <span v-else>
                  {{ trans('app.search.no_data') }}
                </span>
              </div>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2 pb-4">
            <v-pagination v-model="pagination.page" total-visible=10 :length="pages"></v-pagination>
        </div>
    </div>

</template>

<script>
  import debounce from 'lodash/debounce';
  import { trans } from '../../app';
  import { mapGetters, mapState } from 'vuex';
  import { stringify } from 'qs';
  import {FORMAT_DATETIME} from "../../utils/dateFormatter";

  export default {

    data: () => ({
      FORMAT_DATETIME: FORMAT_DATETIME,
      filters: {
        tags: {
          meal: null,
          tag: null,
          diet: null,
          schema: null,
        },
        database: null,
        query: '',
      },
      pages: 0,
      isLoading: true,
      headers: [
        {
          text: '', sortable: false,
        },
        {
          text: trans('app.name'), align: 'left', value: 'title', sortable: true,
        },
        {
          text: trans('app.number_of_days'), align: 'left', value: 'days', sortable: true,
        },
        {
          text: trans('app.desired_kcal'), align: 'left', value: 'desired_diet_energy', sortable: true,
        },
        {
          text: trans('app.createdAt'), align: 'left', value: 'created_at', sortable: true,
        },
        {
          text: '', align: 'left', value: 'name', sortable: false,
        },
      ],
      pagination: {},
      total: 0,
      items: [],
      model: {
        days: 7,
        tags: [],
      },
      errors: {
        title: {
          state: false,
          message: '',
        },
        desired_diet_energy: {
          state: false,
          message: '',
        },
      },
      mode: 'create',
    }),

    computed: {
      ...mapState(['dictionaries']),
      ...mapGetters(['hasPermission', 'canUseSharing']),

      method() {
        return this.mode === 'create' ? 'POST' : 'PATCH';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },

      filters: {
        handler() {
          if (!this.filters.database || typeof this.filters.database === 'object') {
            this.debounceFetch();
          }
        },
        deep: true,
      },
      pagination: {
        handler() {
          this.fetchData();
        },
        deep: true,
      },
    },

    created() {
      this.debounceFetch = debounce(this.fetchData, 300);

      this.$root.$on('reloadTable', this.fetchData);
    },

    methods: {
      redirect(url) {
        window.location = url;
      },
      resetSearch() {
        this.filters = {
          tags: {
            meals: null,
            tags: null,
            diets: null,
          },
          database: null,
          query: '',
        };
      },
      async fetchData() {
        this.isLoading = true;
        const { sortBy, descending, page, rowsPerPage } = this.pagination;

        const query = {
          page: page,
          perPage: rowsPerPage,
          orderBy: sortBy,
          dir: descending ? 'asc' : 'desc',
          ...this.filters,
        };

        const response = await axios.get(`/schemas/data?${stringify(query, { skipNulls: true })}`);

        const { data, meta } = response.data;

        this.items = data;
        this.total = meta.total;
        this.pages = meta.last_page;
        this.isLoading = false;

        this.$emit('dataLoaded', { data });
      },
    },
  };
</script>
<style type="text/scss" scoped lang="scss">
    .favorite__icon {
        transition: .3s color;

        &:hover {
            color: gold;
        }
    }
</style>
